import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiBreadcrumbItem, UiUserInfo } from '../../models/ui-sidebar.model';

@Component({
  selector: 'app-ui-app-header',
  templateUrl: './ui-app-header.component.html',
  styleUrls: ['./ui-app-header.component.scss']
})
export class UiAppHeaderComponent {
  @Input() title = '';
  @Input() breadcrumbs: UiBreadcrumbItem[] = [];
  @Input() appName = 'SupplySync';
  @Input() user: UiUserInfo = { userName: 'Admin', companyName: '', initials: 'AD' };
  @Output() menuToggle = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  onMenuToggle(): void {
    this.menuToggle.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }
}
